import { el, clear } from '../../utils/dom.js';
import { Users } from '../../api/resources.js';
import { dataTable } from '../../components/table.js';
import { openModal, confirm } from '../../components/modal.js';
import { field, readForm } from '../../components/form.js';
import { ok, err } from '../../components/toast.js';

export default async function UsersPage(outlet) {
  clear(outlet);
  let roles = [];
  try { roles = await Users.roles(); } catch (ex) { err(ex.message); }

  outlet.appendChild(el('div', { class: 'page-head' },
    el('h1', {}, 'Usuarios'),
    el('button', { class: 'btn primary', onclick: () => openForm() }, '+ Nuevo'),
  ));

  const host = el('div');
  outlet.appendChild(host);

  async function refresh() {
    host.innerHTML = '<div class="empty">Cargando...</div>';
    try {
      const res = await Users.list({ limit: 100 });
      host.replaceChildren(dataTable({
        columns: [
          { key: 'full_name', label: 'Nombre' },
          { key: 'email',     label: 'Email' },
          { key: 'role_name', label: 'Rol' },
          { key: 'is_active', label: 'Activo', render: (u) => u.is_active ? 'Si' : 'No' },
          { key: '_act', label: '', className: 'right', render: (u) => el('div', { class: 'row-actions' },
            el('button', { class: 'btn sm', onclick: () => openForm(u) }, 'Editar'),
            el('button', { class: 'btn sm', onclick: () => openResetPwd(u) }, 'Resetear clave'),
            el('button', { class: 'btn sm danger', onclick: async () => {
              if (await confirm({ title: 'Eliminar usuario', message: `Eliminar ${u.email}?`, danger: true, confirmText: 'Eliminar' })) {
                try { await Users.remove(u.id); ok('Eliminado'); refresh(); }
                catch (ex) { err(ex.message); }
              }
            } }, 'Eliminar'),
          ) },
        ],
        rows: res.data || [],
      }));
    } catch (ex) {
      host.innerHTML = `<div class="empty">Error: ${ex.message}</div>`;
    }
  }

  function openForm(item) {
    const isEdit = !!item;
    const form = el('form', {
      onsubmit: async (e) => {
        e.preventDefault();
        const d = readForm(form);
        try {
          if (isEdit) {
            await Users.update(item.id, {
              full_name: d.full_name, phone: d.phone || undefined,
              role_id: d.role_id, is_active: d.is_active,
            });
          } else {
            await Users.create({
              email: d.email, password: d.password,
              full_name: d.full_name, phone: d.phone || undefined,
              role_id: d.role_id, is_active: d.is_active,
            });
          }
          ok(isEdit ? 'Actualizado' : 'Creado');
          modal.close();
          refresh();
        } catch (ex) { err(ex.message); }
      },
    });
    const grid = el('div', { class: 'form-grid' });
    grid.append(
      field({ name: 'full_name', label: 'Nombre completo', value: item?.full_name, required: true, full: true }),
      field({ name: 'email', label: 'Email', type: 'email', value: item?.email, required: true, disabled: isEdit }),
      !isEdit ? field({ name: 'password', label: 'Contrasena', type: 'password', required: true }) : null,
      field({ name: 'phone', label: 'Telefono', value: item?.phone }),
      field({ name: 'role_id', label: 'Rol', type: 'select', value: item?.role_id, required: true,
        options: roles.map((r) => ({ value: r.id, label: r.name })) }),
      field({ name: 'is_active', label: 'Activo', type: 'checkbox', value: item ? item.is_active : true }),
    );
    form.appendChild(grid);
    const cancel = el('button', { class: 'btn', type: 'button', onclick: () => modal.close() }, 'Cancelar');
    const submit = el('button', { class: 'btn primary', type: 'submit' }, isEdit ? 'Guardar' : 'Crear');
    const modal = openModal({ title: isEdit ? 'Editar usuario' : 'Nuevo usuario', body: form, footer: [cancel, submit] });
  }

  function openResetPwd(u) {
    const form = el('form', {
      onsubmit: async (e) => {
        e.preventDefault();
        const d = readForm(form);
        try { await Users.resetPassword(u.id, d.new_password); ok('Clave reseteada'); modal.close(); }
        catch (ex) { err(ex.message); }
      },
    });
    form.appendChild(field({ name: 'new_password', label: 'Nueva contrasena (min 8)', type: 'password', required: true, minlength: 8 }));
    const cancel = el('button', { class: 'btn', type: 'button', onclick: () => modal.close() }, 'Cancelar');
    const submit = el('button', { class: 'btn primary', type: 'submit' }, 'Resetear');
    const modal = openModal({ title: `Resetear clave — ${u.email}`, body: form, footer: [cancel, submit] });
  }

  refresh();
}
